import { BorerActivityTypeDocument } from '../BorerActivityType/queryBuilder';
import { BorerShiftDocument } from '../BorerShift/queryBuilder';
import { BorerShiftCrewDocument } from '../BorerShiftCrew/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, push, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import {
  BorerActivityDocument,
  borerActivityPullQueryBuilder,
  borerActivityPushModifer,
  borerActivityPushQueryBuilder,
} from './queryBuilder';

export function borerActivityFamilyMember(
  configBuilder: ConfigBuilder,
  borerActivityType: FamilyMember<BorerActivityTypeDocument>,
  borerShift: FamilyMember<BorerShiftDocument>,
  borerShiftCrew: FamilyMember<BorerShiftCrewDocument>,
): FamilyMember<BorerActivityDocument> {
  // BORER_ACTIVITY uses borerShiftActivityFeed and thus refers to the borer_shift_activity table.
  const syncConfig = configBuilder<BorerActivityDocument>(RxdbCollectionNameV2.BORER_ACTIVITY);
  doNotAutoSync(syncConfig);

  pull(syncConfig, borerActivityPullQueryBuilder);
  const pushConfig = push(syncConfig, borerActivityPushQueryBuilder);
  pushConfig.modifier = borerActivityPushModifer;

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.BORER_ACTIVITY, replicationState, [
    borerActivityType,
    borerShift,
    borerShiftCrew,
  ]);
}
